import * as React from 'react'
import { debounce, hasValue, parseValue } from '../../../util';
import classNames from 'classnames';
import { ColorPallet, HorizontalScrollList, IColorPickerProps, IconButton, Input, Label, Loading, Modal, PortalContainer, SearchBox, Tooltip, useDebounce, useToast } from 'uxp/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { IContextProvider } from '../../../uxp';
import { generateIconProp } from '../icon-selector/IconEditor';
import { WidgetDesignerPillInput } from '../pill-input/PillInput';
import { IContextData, useInitialContextData } from '../../../hooks/useContextData';


export const PropertyContainer: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-container'> {props.children} </div>
}

export const PropertyContainerTitle: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-container-title'> {props.children} </div>
}
export const PropertyContainerSubTitle: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-container-sub-title'> {props.children} </div>
}

export const PropertyGroup: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-group'> {props.children} </div>
}

export const PropertyGroupTitle: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-group-title'> {props.children} </div>
}

export const Property: React.FunctionComponent<{ id?: string, styles?: React.CSSProperties }> = props => {
    return <div
        className={'wd-ui-property'}
        id={props.id}
        style={props.styles}
    >
        {props.children}
    </div>
}

export const PropertyTitle: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-title'> {props.children} </div>
}

export const PropertySubTitle: React.FunctionComponent<{}> = props => {
    return <div className='wd-ui-property-sub-title'> {props.children} </div>
}

export function makeColorTransparent(color: string, opacity: number) {
    if (!color) return null
    let m = color.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
    if (m) {
        return `rgba(${m[1]},${m[2]},${m[3]},${opacity})`;
    }
    let m2 = color.match(/^rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([0-9.]+)\s*\)$/i);
    if (m2) {
        return `rgba(${m2[1]},${m2[2]},${m2[3]},${opacity})`;
    }
    if (!color.startsWith('#')) {
        //todo: handle non hex colors
        return color;
    }
    return color.substring(0, 7) + (255 * opacity).toString(16);
}


interface IBackgroundPositionEditorProps {
    position: string,
    onChange: (s: string) => void
}
export const BackgroundPositionEditor: React.FunctionComponent<IBackgroundPositionEditorProps> = props => {
    let [position, setPosition] = React.useState<string>('center center')

    let xPos = ['left', 'center', 'right']
    let yPos = ['top', 'center', 'bottom']

    React.useEffect(() => {
        if (hasValue(props.position)) {
            let parts = props.position.split(" ", 2)
            console.log("parts ", parts);

            if (parts.length == 2) setPosition(props.position)
            else if (xPos.indexOf(parts[0]) !== -1) setPosition(`${parts[0]} center`)
            else setPosition(`center ${parts[0]}`)

        }
        else setPosition('center center')
    }, [props.position])

    return <div className='wd-property-bg-position-editor'>
        <div className="position-editor">
            {xPos.map((x, i) => {
                return yPos.map((y, j) => {
                    let pos = `${x} ${y}`

                    return (
                        <div
                            className={classNames("position", `${x}-${y}`, { 'selected': position == pos })}
                            onClick={() => props.onChange(pos)}
                            key={pos}
                        ></div>
                    )
                })
            })}

        </div>
    </div>
}

interface ICustomColorPicker {
    color: string,
    onChange: (color: string) => void
    defaultColors?: string[],
    contextData: IContextData
}

export let DefaultColors: string[] = [
    //primary
    '#5652C2',
    '#BC59C3',
    '#BB597B',
    '#72C1C7',
    '#ABE087',
    '#C76663',

    //secondary
    '#424242',
    '#F8F8F8',
    '#74C6AB',
    '#A4D6EB',
    '#E7E0FC',
    '#C4EDFC',
    '#F9DAF9',
    '#CCCCF6',
    '#97DBCF',
    '#CFE9AD',
];
export const CustomColorPicker: React.FunctionComponent<ICustomColorPicker> = (props) => {

    let { color, onChange, defaultColors, contextData } = props

    if (!defaultColors || defaultColors.length == 0) defaultColors = DefaultColors

    let buttonRef = React.useRef(null)

    const [show, setShow] = React.useState(false)
    const [showExpression, setShowExpression] = React.useState(false)
    const [coords, setCoords] = React.useState<any>({})

    const minWidth = 250, minHeight = 300

    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        toggleTooltip()
    }

    const toggleTooltip = () => {
        const buttonDetails = buttonRef.current.getBoundingClientRect();

        const { top, left, right, bottom, width, height } = buttonDetails
        const { innerWidth, innerHeight } = window

        let _coords: any = {}
        let vPos = 'top'
        let hPos = 'left'

        if (top + minHeight > innerHeight) vPos = 'bottom'
        if (left + minWidth > innerWidth) hPos = 'right'

        if (vPos == 'top') _coords.top = top
        else _coords.bottom = innerHeight - bottom

        if (hPos == 'left') _coords.left = left
        else _coords.right = innerWidth - right
        // else _coords.right = 
        console.log(_coords, "asdf")

        setCoords(_coords);
        setShow(prev => !prev);
    }

    function renderPicker() {
        return <PortalContainer
            hasBackdrop={true}
            disableScroll={true}
            onClickBackdrop={() => setShow(false)}
        >
            <div className={classNames("uxp-color-picker-content")} style={coords} >
                <div className="toolbar">
                    <div className="title">Select a color</div>


                    <div className="close-btn" onClick={() => { setShow(false) }}>
                        <div className="icon-cont">
                            <div className="icon"></div>
                        </div>
                    </div>

                </div>

                <ColorPallet

                    color={color}
                    onChange={s => {
                        onChange(s)
                        setShow(false)
                    }}
                    onCancel={() => { setShow(false) }}
                />
            </div>
        </PortalContainer>
    }

    function renderExpression() {
        return <WidgetDesignerPillInput
            contextData={contextData}
            className={'widget-designer-pill-input'}
            value={color}
            onChange={(e) => {
                onChange(e)
            }}
            showFields={true}
            showThemes={true}
        />
    }

    return <div className="wd-custom-color-picker-container">
        <div className="colors-container" ref={buttonRef}>
            <div className="custom-picker-btn"
                onClick={onClick}
            >
                <div className="picker-icon" style={{ backgroundColor: makeColorTransparent(color, 0.4) }}>
                    <div className="picked-color" >
                        <FontAwesomeIcon icon={['fas', 'circle']} style={{ color: color }} />
                    </div>
                    <FontAwesomeIcon icon={['far', 'palette']} />
                </div>
            </div>

            <HorizontalScrollList
                items={defaultColors}
                renderItem={(c) => {
                    return <div style={{ backgroundColor: c }} className={classNames("color-icon color", { 'selected': color == c })}
                        onClick={() => onChange(c)}
                    >
                        {/* <FontAwesomeIcon icon={['fas', 'circle']} style={{ color: c }} /> */}
                    </div>
                }}
                className="wd-horizontal-scroll-list-small"
            />

            <div className='custom-expression-btn' 
                style={{background: /{\$(.*?)}/g.test(color) ? "rgba(255,165,0,0.4)" : "" }}
                onClick={() => {
                    setShowExpression(prev => !prev)
                }}>
                <FontAwesomeIcon  icon={['fas', 'tools']} />
            </div>
            {show && renderPicker()}

        </div>
        {showExpression && renderExpression()}

    </div>
}


export interface IColorForRange {
    from: number,
    color: string
}

export interface IColorPickerDialog {
    show: boolean,
    colorForRange: IColorForRange,
    onChange: (colorForRange: IColorForRange) => void,
    onClose: () => void,
    triggerButtonRef: React.MutableRefObject<HTMLElement>
}

export const ColorPickerDialog: React.FunctionComponent<IColorPickerDialog> = (props) => {

    const [coords, setCoords] = React.useState<any>({})

    const minWidth = 250, minHeight = 300
    const adjustBounds = () => {
        const buttonDetails = props.triggerButtonRef.current.getBoundingClientRect();

        const { top, left, right, bottom, width, height } = buttonDetails
        const { innerWidth, innerHeight } = window

        let _coords: any = {}
        let vPos = 'top'
        let hPos = 'left'

        if (top + minHeight > innerHeight) vPos = 'bottom'
        if (left + minWidth > innerWidth) hPos = 'right'

        if (vPos == 'top') _coords.top = top
        else _coords.bottom = innerHeight - bottom

        if (hPos == 'left') _coords.left = left
        else _coords.right = innerWidth - right
        setCoords(_coords);
    }

    React.useLayoutEffect(adjustBounds, [props.show])

    if (props.show) {

        return <PortalContainer
            hasBackdrop={true}
            disableScroll={true}
            onClickBackdrop={() => props.onClose()}
        >
            <div className={classNames("uxp-color-picker-content")} style={coords} >
                <div className="toolbar">
                    <div className="title">Select a color for range</div>

                    <div className="close-btn" onClick={() => props.onClose()}>
                        <div className="icon-cont">
                            <div className="icon"></div>
                        </div>
                    </div>

                </div>

                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '14px' }}>
                    <Label>Change progress bar color to this color from </Label>
                    <Input
                        type="number"
                        value={String(props.colorForRange.from)}
                        onChange={s => {
                            props.onChange({ ...props.colorForRange, from: Number(s) })
                        }}
                        className="widget-designer-input"
                    />
                </div>

                <ColorPallet
                    color={props.colorForRange?.color}
                    onChange={s => {
                        props.onChange({ ...props.colorForRange, color: s })
                        props.onClose()
                    }}
                    onCancel={() => props.onClose()}
                />
            </div>
        </PortalContainer>

    } else {
        return <></>
    }
}

export interface IColorsForMultipleRangesPicker {
    colorsForRanges: IColorForRange[],
    onChange: (colorsForRanges: IColorForRange[]) => void
}

export const ColorsForMultipleRangesPicker: React.FunctionComponent<IColorsForMultipleRangesPicker> = (props) => {

    let { colorsForRanges, onChange } = props
    let [selectedColorForRangeIndex, setSelectedColorForRangeIndex] = React.useState<number>()

    let addButtonRef = React.useRef(null)

    const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false)

    function renderPicker() {
        return (
            <ColorPickerDialog
                onClose={() => {
                    setShowColorPicker(false)
                    setSelectedColorForRangeIndex(null)
                }}
                show={showColorPicker}
                onChange={(v) => {
                    let d = [...colorsForRanges]
                    d[selectedColorForRangeIndex] = v
                    onChange(d)
                }}
                triggerButtonRef={addButtonRef}
                colorForRange={colorsForRanges[selectedColorForRangeIndex]}
            />
        )
    }


    return <div className="wd-color-range-picker-container">
        <div className="colors-container" ref={addButtonRef}>

            <HorizontalScrollList
                items={colorsForRanges}
                renderItem={(c, index) => {
                    return (
                        <div
                            style={{ backgroundColor: c?.color }}
                            className={classNames("color-icon color", { 'selected': selectedColorForRangeIndex == index })}
                            onClick={() => {
                                setSelectedColorForRangeIndex(index)
                                setShowColorPicker(true)
                            }}>
                            <span className="text" style={{ color: c?.color }}>
                                {c?.from + "%"}
                            </span>
                        </div>
                    )
                }}
                className="wd-horizontal-scroll-list-small"
            />

            {(!!selectedColorForRangeIndex || selectedColorForRangeIndex == 0) && renderPicker()}

            <div className="add-new-color-range"
                onClick={() => {
                    let from = Math.max(...colorsForRanges.map((v) => v.from)) + 1
                    onChange([...colorsForRanges, { from, color: DefaultColors[colorsForRanges.length % DefaultColors.length] }])
                }}
            >
                <Tooltip position='bottom' content={'Add new color range'}>
                    <div className="add-new-color-range-icon" style={{ backgroundColor: makeColorTransparent('#121212', 0.4) }}>
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                    </div>
                </Tooltip>
            </div>

        </div>

    </div>
}

let TextAlignDirections: string[] = ['left', 'center', 'right', 'justify']
interface ITextAlignEditorProps {
    value: string,
    onChange: (value: string) => void
}
export const TextAlignEditor: React.FunctionComponent<ITextAlignEditorProps> = (props) => {

    let { value, onChange } = props

    return <div className="wd-text-align-editor-container">
        {TextAlignDirections.map((d, i) => {

            let iconName = 'align-' + d as IconName
            return <div key={i}
                className={classNames("direction", { "selected": value == d })}
                onClick={() => { onChange(d) }}
            >
                <FontAwesomeIcon icon={['fas', iconName]} />
            </div>
        })}
    </div>
}

export function escapeUnit(value: string, unit: string) {
    return value.replace(unit, '').trim()
}

export interface ITypeSelectorType {
    icon: string,
    value: string,
    label?: string
}
export const TypeSelectorComponent: React.FunctionComponent<{ types: ITypeSelectorType[], selected: string, onChange: (value: string) => void, itemWidth: string, iconStyles?: React.CSSProperties }> = (props) => {
    const iconStyles:React.CSSProperties = props.iconStyles || {}
    
    return <div className={classNames('wd-type-selector-component-container')}>
        {props.types.map((t, i) => {
            return <div
                className={classNames('wd-type-selector-component-type-container', { 'selected': props.selected == t.value })}
                onClick={() => props.onChange(t.value)}
            >
                <div className="wd-type-selector-component-type-content">
                    <div className='label'>{t.label || ''}</div>
                    <FontAwesomeIcon 
                        style={{ width: props.itemWidth, ...iconStyles }} 
                        icon={generateIconProp(t.icon)} 
                    />
                </div>
            </div>
        })}
    </div>
}